import React, {useMemo} from 'react';

const SllTierRunGraphSvg = ({value,place}) => {

    const gradiantValue = useMemo(() => {
        try {
            if (value === 0) {
                return {
                    first: 0,
                    second: 0,
                    last: 0,
                    value: 0,
                }
            } else if (value > 99) {
                return {first: 0.32, second: 0.61, last: 1,value:1}
            }

            const dividedValue = Number((value / 100).toFixed(4));




            return {
                first: dividedValue * 0.3,
                second:  dividedValue * 0.6,
                last:  dividedValue * 0.9,
                value: dividedValue,
            }


        } catch (e) {
            return {
                first: 0,
                second: 0,
                last: 0,
                value: 0,
            }
        }

    }, [value]);


    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="170" height="6.6" viewBox="0 0 170 7" fill="none">
            <path d="M40.4165 6.46154H21.6752L25.5157 0H44.257L40.4165 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M62.0383 6.46154H43.2971L47.1376 0H65.8788L62.0383 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M83.6602 6.46154H64.9189L68.7594 0H87.5007L83.6602 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M105.282 6.46154H86.5408L90.3813 0H109.123L105.282 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M126.904 6.46154H108.163L112.003 0H130.744L126.904 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M148.526 6.46154H129.784L133.625 0H152.366L148.526 6.46154Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M169.419 3.15189L166.146 6.46154H151.406L155.247 0H166.146L169.419 3.15189Z"
                  fill={`url(#002202_${place})`}/>
            <path d="M18.7413 6.46154H0L3.84051 0H22.5818L18.7413 6.46154Z" fill={`url(#002202_${place})`}/>
            <defs>
                <linearGradient xmlns="http://www.w3.org/2000/svg" id={`002202_${place}`} x1="0" y1="3.23077"
                                x2="169.419" y2="3.23077" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#53C6AA" stopOpacity="0"/>
                    <stop offset={gradiantValue.first} stopColor="#53C6AA" stopOpacity="0.7"/>
                    <stop offset={gradiantValue.second} stopColor="#53C6AA"/>
                    <stop offset={gradiantValue.last} stopColor="#6FFFDC"/>
                    <stop offset={gradiantValue.value} stopColor="#8E8E8E"/>
                </linearGradient>
            </defs>
        </svg>);
};

export default SllTierRunGraphSvg;